import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { sendResetPasswordEmail } from '../../actions/resetPassword'

import { Link } from 'react-router-dom'

import '../Login/Login.scss'
import logo from '../../assets/reggora-app.png'

import { LoadingOutlined, MailOutlined } from '@ant-design/icons'

import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'

import { Button, Input, notification } from 'antd'
const FormItem = Form.Item

class RequestResetPasswordEmail extends Component {
    state = {
      isAwaitingMessage: true,
    }

    componentDidUpdate() {
      const { isFinished, error } = this.props
      const { isAwaitingMessage } = this.state
      if (isAwaitingMessage && isFinished) {
        if (error) {
          // error!
          const config = {
            message: 'Error',
            description: error,
          }
          notification.error(config)
        } else {
          // success!
          const config = {
            message: 'Success',
            description: 'A reset password link has been sent to your email address.',
          }
          notification.success(config)
        }
        this.setState({
          isAwaitingMessage: false,
        })
      }
    }

    getConditionalContent = () => {
      if (this.props.isSending) {
        return <LoadingOutlined />
      }
    }

    onSubmit = (e) => {
      e.preventDefault()
      this.props.form.validateFields((err, values) => {
        if (!err) {
          this.props.actions.sendResetPasswordEmail(values.email)
          this.setState({
            isAwaitingMessage: true,
          })
        }
      })
    }

    render() {
      const {
        getFieldDecorator,
        getFieldError,
        getFieldValue,
      } = this.props.form
      return (
            <div className='login'>

                <div className="logoContainer">
                        <img src={logo} className='login-form-logo' />
                </div>
                <div className="shadowWrapper">

                <Form className='login-form' onSubmit={this.onSubmit} data-testid="request-reset-password-form">
                <h2>
                    Forgot your password? No problem, enter your email below and
                    we&apos;ll send you a link to change it.
                </h2>
                    <FormItem
                        label='Email (example@reggora.com)'
                    >
                        {getFieldDecorator('email', {
                          rules: [{
                            type: 'email', message: 'Please enter a valid email address',
                          }, {
                            required: true, message: 'Please enter your email address',
                          }],
                        })(
                            <Input
                                onChange={this.onEmailChange}
                                prefix={<MailOutlined />}
                                placeholder='example@reggora.com'
                                data-testid="request-reset-email-input"
                            />
                        )}
                    </FormItem>
                    <FormItem>
                        <Button
                            type='primary'
                            htmlType='submit'
                            disabled={getFieldError('email') || !getFieldValue('email')}
                            data-testid="request-reset-submit-button"
                        >
                            Send Password Reset Link
                        </Button>
                    </FormItem>
                </Form>
                <div className="loginFormBottom">
                    <p><Link to='/login' data-testid="request-reset-back-to-login-link">Back to Login</Link></p>
                </div>
                {this.getConditionalContent()}
                </div>
            </div>
      )
    }
}

function mapStateToProps(state) {
  return {
    isSending: state.resetPassword.isSending,
    isFinished: state.resetPassword.isFinished,
    error: state.resetPassword.errorMessage,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ sendResetPasswordEmail }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(RequestResetPasswordEmail))
